<script setup lang="ts">
import type { CmsBlockPluebelCmsElementsHerobannerWithTabs } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsBlockPluebelCmsElementsHerobannerWithTabs;
}>();

const {
  text,
  tabmenu,
  headline,
  tabmenu_name,
  heroimage_mobile,
  heroimage_desktop,
} = props.content.config;
</script>

<template>
  <section class="hero-section relative" v-if="heroimage_desktop.value || heroimage_mobile.value">
    <figure class="img-cover h-[390px] md:h-[440px] xl:h-[535px] max-h-[800px] flex items-center justify-center overflow-hidden">
      <img
        v-if="heroimage_desktop.value"
        :src="heroimage_desktop.value?.url"
        loading="lazy"
        format="webp"
        :class="{ 'hidden md:block': heroimage_mobile.value }"
        :alt="
          heroimage_desktop.value?.alt ||
          heroimage_desktop.value?.fileName ||
          'Banner Desktop'
        "
        :width="heroimage_desktop.value?.metaData?.width || '2186'"
        :height="heroimage_desktop.value?.metaData?.height || '1458'"
      />
      <img
        v-if="heroimage_mobile.value"
        :src="heroimage_mobile.value?.url"
        loading="lazy"
        format="webp"
        :class="{ 'block md:hidden': heroimage_desktop.value }"
        :alt="
          heroimage_mobile.value?.alt ||
          heroimage_mobile.value?.fileName ||
          'Banner Mobile'
        "
        :width="heroimage_mobile.value?.metaData?.width || '2186'"
        :height="heroimage_mobile.value?.metaData?.height || '1458'"
      />
    </figure>
    <div
      class="heroTxt w-full top-16 lg:top-20 xl:top-28"
      :class="{ absolute: heroimage_desktop.value || heroimage_mobile.value }"
    >
      <div class="container">
        <div class="w-full max-w-[860px] xl:pt-2 text-white">
          <h1 class="mb-4 xl:mb-8" v-if="headline.value">
            {{ headline.value }}
          </h1>
          <p v-if="text.value">{{ text.value }}</p>
        </div>
      </div>
    </div>
    <div
      class="cat-hero-sec absolute w-full bottom-6 lg:bottom-8 xl:bottom-12 max-w-full"
    >
      <div class="container">
        <div class="w-full overflow-hidden rounded-xl">
          <div
            class="inline-flex w-full md:w-auto flex-col md:flex-row items-center gap-2 md:gap-5 xl:gap-11 bg-cust_cream py-3 lg:py-5 ps-4 lg:ps-6 rounded-xl lg:rounded-3xl overflow-hidden"
          >
            <h4
              class="w-full md:w-[172px] lg:w-auto mb-0 text-15px md:text-lg lg:text-xl xl:text-26px whitespace-nowrap font-redit_sans_con font-extrabold tracking-[0.10px] lg:tracking-[0.20px] xl:tracking-[0.26px]"
              v-if="tabmenu_name.value"
            >
              {{ tabmenu_name.value }}
            </h4>
            <div class="block pr-[15px] md:pr-[0px] overflow-x-auto max-w-[calc(100vw-50px)] md:max-w-[calc(100vw-255px)] lg:max-w-full">
              <div
                class="lg:w-auto inline-flex gap-2 md:gap-3 xl:gap-4 md:pe-2 lg:pe-4"
              >
                <template v-for="(menu, index) in tabmenu.value" :key="index">
                  <SharedButton
                    v-if="menu.button"
                    :button="menu.button"
                    :key="menu.id"
                    class="green-tags font-thin"
                  />
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
